export const FETCH_LOAD_INIT_ACTION = "FETCH_LOAD_INIT_ACTION";
export const FETCH_LOAD_SUCCESS_ACTION = FETCH_LOAD_INIT_ACTION + "_SUCCESS";
export const FETCH_LOAD_FAIL_ACTION = FETCH_LOAD_INIT_ACTION + "_ERROR";

export const FETCH_LOAD_ID_INIT_ACTION = "FETCH_LOAD_ID_INIT_ACTION";
export const FETCH_LOAD_ID_SUCCESS_ACTION =
  FETCH_LOAD_ID_INIT_ACTION + "_SUCCESS";
export const FETCH_LOAD_ID_FAIL_ACTION = FETCH_LOAD_ID_INIT_ACTION + "_ERROR";

export const TAB_KEY_INIT_ACTION = "TAB_KEY_INIT_ACTION";

export const FETCH_SUBLOG_INIT_ACTION = "FETCH_SUBLOG_INIT_ACTION";
export const FETCH_SUBLOG_SUCCESS_ACTION =
  FETCH_SUBLOG_INIT_ACTION + "_SUCCESS";
export const FETCH_SUBLOG_FAIL_ACTION = FETCH_SUBLOG_INIT_ACTION + "_ERROR";

export const REJECT_LOAD_INIT = "REJECT_LOAD_INIT";
export const REJECT_LOAD_SUCCESS = REJECT_LOAD_INIT+"_SUCCESS";
export const REJECT_LOAD_FAIL = REJECT_LOAD_INIT+"_FAIL";

// export const FETCH_LOAD_DRIVER_INIT_ACTION = "FETCH_LOAD_DRIVER_INIT_ACTION";
// export const FETCH_LOAD_DRIVER_SUCCESS_ACTION =
//   FETCH_LOAD_DRIVER_INIT_ACTION + "_SUCCESS";
// export const FETCH_LOAD_DRIVER_FAIL_ACTION =
//   FETCH_LOAD_DRIVER_INIT_ACTION + "_ERROR";

// export const FETCH_LOAD_VEHICLE_INIT_ACTION = "FETCH_LOAD_VEHICLE_INIT_ACTION";
// export const FETCH_LOAD_VEHICLE_SUCCESS_ACTION =
//   FETCH_LOAD_VEHICLE_INIT_ACTION + "_SUCCESS";
// export const FETCH_LOAD_VEHICLE_FAIL_ACTION =
//   FETCH_LOAD_VEHICLE_INIT_ACTION + "_ERROR";

export const GET_PAYMODE_INIT = "GET_PAYMODE_INIT";
export const GET_PAYMODE_SUCCESS = GET_PAYMODE_INIT+"_SUCCESS";
export const GET_PAYMODE_FAIL = GET_PAYMODE_INIT+"_FAIL";
